import Hightlighter from 'react-highlight-words';
import * as S from './ChooseCategories.styled';
import { Checkbox } from 'components';

export const Content = ({ foundedCategories, search, selectCategory }) => {
  return (
    <>
      {foundedCategories?.map(({ text, value, selected, isGlobal = false }) => (
        <S.Group key={value}>
          <S.Row>
            <Checkbox
              id={`${value}`}
              isChecked={isGlobal || selected}
              name={value}
              onChange={selectCategory}
              isDisabled={isGlobal}
            />
            <S.GroupName onClick={() => !isGlobal && selectCategory(!selected, value)}>
              <Hightlighter textToHighlight={text} searchWords={[search]} highlightTag='strong' />
            </S.GroupName>
          </S.Row>
        </S.Group>
      ))}
    </>
  );
};
